import { render, staticRenderFns } from "./purchaseRequisition.vue?vue&type=template&id=f61a7bbc&scoped=true"
import script from "./purchaseRequisition.vue?vue&type=script&lang=js"
export * from "./purchaseRequisition.vue?vue&type=script&lang=js"
import style0 from "./purchaseRequisition.vue?vue&type=style&index=0&id=f61a7bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61a7bbc",
  null
  
)

export default component.exports